import React, {ReactElement, ReactNode} from 'react'
import {
    Tooltip,
    TooltipContent,
    TooltipTrigger,
} from '../TiptapEditor/components/tiptap-ui-primitive/tooltip'
import styles from './index.module.scss'

interface InfoTooltipProps {
    children: ReactElement
    content: ReactNode
}

// The bubble carries a 5px arrow below it, so the offset has to clear the arrow
// before it starts spacing the tooltip off the element itself.
const ARROW_HEIGHT = 5
const GAP_ABOVE_ELEMENT = 2.5

export default function InfoTooltip({children, content}: InfoTooltipProps) {
    return (
        <Tooltip placement="top" sideOffset={ARROW_HEIGHT + GAP_ABOVE_ELEMENT} delay={0}>
            <TooltipTrigger asChild>{children}</TooltipTrigger>
            <TooltipContent className={styles.tooltip}>{content}</TooltipContent>
        </Tooltip>
    )
}
